var initDatePicker = function () {
    var elems = document.querySelectorAll(".datepicker");
    M.Datepicker.init(elems, { format: "yyyy-mm-dd", container: "body" });
};

document.addEventListener("DOMContentLoaded", initDatePicker);
